import { CustomDomainInfo, TemplateIntakeForm } from "schemas/dashboard";

export type AdminAddOnItem = {
  id: number;
  itemName: string;
  createdAt: number;
  quantity: number;
  document?: string;
  domainInfo?: CustomDomainInfo;
  purchaseDetails?: any;
  templateIntakeForms?: TemplateIntakeForm[];
};

export type BackgroundDetails = {
  question: string;
  answer: string;
};

export enum OnboardingReviewRequestStatus {
  pending = "pending",
  fulfilled = "fulfilled",
}

export type OnboardingReviewRequest = {
  id: number;
  status: OnboardingReviewRequestStatus;
  isArchived: boolean;
  planName: string;
};
